// extracted by mini-css-extract-plugin
module.exports = {"containerError":"Error404_containerError__26HLL","titleError":"Error404_titleError__Cbk-O","link":"Error404_link__2wSOS","buttonBack":"Error404_buttonBack__2Gigi"};